const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Supplier Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/ServiceTypeMultiFilter"),
    props: {
      filterName: "supplierType_eq",
      label: "Service Type",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "email_contains",
      label: "Email",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "code_contains",
      label: "Code",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destinationId",
      label: "Destination",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/HeadOfficeFilter"),
    props: {
      filterName: "headofficeId",
      label: "HeadOffice",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/CurrencyFilter"),
    props: {
      filterName: "currency_eq",
      label: "Currency Code",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      trueLabel: "Not in Use",
      falseLabel: "In Use",
      label: "Not In Use",
    },
    defaultValue: { not_in_use_eq: false },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "market_place_eq",
      trueLabel: "Market Place On",
      falseLabel: "Market Place Off",
      label: "Market Place",
    },
    defaultValue: { market_place_eq: false },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/suppliers/suppliers-filters.js